"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var generateSizes = function generateSizes(size) {
  switch (size) {
    case 'small':
      return {
        height: 18,
        width: 18,
        viewBox: '0 0 36 36',
        ie: {
          height: 21,
          width: 21,
          translate: {
            x: 0,
            y: 0
          },
          scale: 0.87
        }
      };

    default:
      return {
        height: 24,
        width: 24,
        viewBox: '0 0 36 36',
        ie: {
          height: 24,
          width: 24,
          translate: {
            x: 0,
            y: 0
          },
          scale: 1
        }
      };
  }
};

var Spin = function Spin(_ref) {
  var size = _ref.size,
      operation = _ref.operation;
  var data = generateSizes(size); // success svg

  if (operation === 'success') {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
        height: data.height,
        width: data.width,
        className: "success operationSVG",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 130.2 130.2",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
          className: "circle",
          fill: "none",
          stroke: "#73AF55",
          strokeWidth: "10",
          strokeMiterlimit: "10",
          cx: "65.1",
          cy: "65.1",
          r: "62.1"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polyline", {
          className: "check",
          fill: "none",
          stroke: "#73AF55",
          strokeWidth: "9",
          strokeLinecap: "round",
          strokeMiterlimit: "10",
          points: "100.2,40.2 51.5,88.8 29.8,67.5 "
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
        className: "iesvg",
        width: data.ie.width,
        height: data.ie.height,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
          cx: data.ie.width / 2,
          cy: data.ie.width / 2,
          r: data.ie.width / 2 - 1,
          stroke: "black",
          strokeWidth: "2",
          fill: "none"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          transform: "scale(".concat(data.ie.scale, ", ").concat(data.ie.scale, ") translate(").concat(data.ie.translate.x, ",").concat(data.ie.translate.y, ")"),
          xmlns: "http://www.w3.org/2000/svg",
          d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
        })]
      })]
    });
  } // failure svg


  if (operation === 'failure') {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
        height: data.height,
        width: data.width,
        className: "failure operationSVG",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 130.2 130.2",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
          className: "circle",
          fill: "none",
          stroke: "#D06079",
          strokeWidth: "10",
          strokeMiterlimit: "10",
          cx: "65.1",
          cy: "65.1",
          r: "62.1"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
          className: "line",
          fill: "none",
          stroke: "#D06079",
          strokeWidth: "9",
          strokeLinecap: "round",
          strokeMiterlimit: "10",
          x1: "34.4",
          y1: "37.9",
          x2: "95.8",
          y2: "92.3"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
          className: "line",
          fill: "none",
          stroke: "#D06079",
          strokeWidth: "9",
          strokeLinecap: "round",
          strokeMiterlimit: "10",
          x1: "95.8",
          y1: "38",
          x2: "34.4",
          y2: "92.2"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
        className: "iesvg",
        width: data.ie.width,
        height: data.ie.height,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
          cx: data.ie.width / 2,
          cy: data.ie.width / 2,
          r: data.ie.width / 2 - 1,
          stroke: "black",
          strokeWidth: "2",
          fill: "none"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          transform: "scale(".concat(data.ie.scale, ", ").concat(data.ie.scale, ") translate(").concat(data.ie.translate.x, ",").concat(data.ie.translate.y, ")"),
          xmlns: "http://www.w3.org/2000/svg",
          d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
        })]
      })]
    });
  } // loading svg


  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    version: "1.1",
    id: "loader-1",
    className: "operationSVG svganimation loadder",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: data.width,
    height: data.height,
    viewBox: "0 0 50 50",
    style: {
      enableBackground: 'new 0 0 50 50'
    },
    xmlSpace: "preserve",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      className: "circle",
      d: "M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
    })
  });
};

var _default = Spin;
exports["default"] = _default;

//# sourceMappingURL=Spin.js.map